import { SettingComponent } from "../../components";

export default function NavigationSettingPage() {
  return <SettingComponent.NavigationSettingPage />;
}
